<div class="admin">
  <div class="login row d-flex flex-column justify-content-center align-items-center">
    <div class="logo d-flex align-items-center justify-contet-between">
      <a>
        <img src="../../../assets/images/MC-white.svg" />
      </a>
      <div class="slogan">
        <span class="slogan-ar"> مركز الامتياز التجاري </span>
        <span class="slogan-en"> Franchise Center </span>
      </div>
    </div>

    <div class="col-md-4">
      <form class="form login-form" [formGroup]="loginForm">
        <div class="mb-4" *ngIf="errorMessage">
          <ngb-alert type="danger" (close)="errorMessage = null">
            {{ errorMessage }}
          </ngb-alert>
        </div>
        <p class="welcome text-center">مرحبا بعودتك</p>
        <p class="title text-center">ادخل بيانات حسابك، لتسجيل الدخول</p>
        <div class="form-group">
          <label for="email">البريد الإلكتروني</label>
          <input type="email" id="email" class="form-control" formControlName="email"
            placeholder="ادخل بريدك الإلكتروني" />
        </div>
        <div class="form-group">
          <label for="password"> كلمة المرور </label>
          <input [type]="showPassword ? 'text' : 'password'" formControlName="password" id="password"
            class="form-control" />
          <div class="input-icon" (click)="showPassword = !showPassword">
            <i class="fa-solid fa-eye"></i>
          </div>
        </div>
        <div class="form-group">
          <label for="captchaInput">رمز التحقق</label>

          <input type="text" maxlength="4" id="captchaInput" class="form-control" formControlName="captchaInput"
            placeholder="أدخل رمز التحقق" />
          <div class="input-img" (click)="refreshCaptcha()">
            <img *ngIf="captchaImageUrl" [src]="captchaImageUrl | safeResourceUrl" title="اضغط لتغيير الرمز"
              alt="Captcha Image" />
          </div>
        </div>

        <div class="login-button">
          <a class="p-1 float-left"  routerLink="/forgot-password">{{"AdminLogin.ForgotPassword" | translate}}</a>
          <button class="btn DS btn-green btn-block mt-2" (click)="login()">
            تسجيل الدخول
          </button>
        </div>
      </form>
    </div>
  </div>
</div>